import { FC } from 'react';
import './Footer.scss';

export const Footer: FC = () => {
  return (
    <footer className="footer">
      <div className="footer_left-side">
        <span>All rights reserved © monday.com</span>
      </div>
    </footer>
  );
};
